import { ReadOnlyKeyValueStorage } from './ReadOnlyKeyValueStorage';

export interface PrivateKeyStorage {
  getPrivateKey(): string | undefined;
}

export function createPrivateKeyStorage(
  storages: Array<ReadOnlyKeyValueStorage>,
  key = 'privateKey',
): PrivateKeyStorage {
  function getPrivateKey(): string | undefined {
    for (let i = 0; i < storages.length; i += 1) {
      const storage = storages[i];

      const privateKey = storage.getItem(key);
      if (privateKey) {
        if (privateKey.startsWith('0x')) {
          return privateKey;
        }

        if (privateKey.length === 64) {
          return `0x${privateKey}`;
        }

        return privateKey;
      }
    }

    return undefined;
  }

  return {
    getPrivateKey,
  };
}
